import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


import CreateWithdrawal from 'views/Transactions/CreateWithdrawal'
import Form from 'views/Transactions/Form'
import List from 'views/Transactions/List'


class Transactions extends React.Component {
  render() {
    const {match}=this.props;
    return (
          <Switch>
            <Route path={`${match.path}/add`} component={CreateWithdrawal}/>
            <Route path={`${match.path}/:id`} component={Form}/>
            <Route component={List}/>
          </Switch>
    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(Transactions);



// WEBPACK FOOTER //
// ./src/views/Transactions/Transactions.jsx